import { render, staticRenderFns } from "./KecelakaanMiniCard.vue?vue&type=template&id=8711c084"
import script from "./KecelakaanMiniCard.vue?vue&type=script&lang=js"
export * from "./KecelakaanMiniCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports